import { fetchEncryptGet } from '../../providers/Fetch';

import {
  AREA_ERROR,
  AREA_REQUEST,
  AREA_SUCCESS,
} from './types';

export const areaError = error => ({
  type: AREA_ERROR,
  error,
});

export const areaRequest = {
  type: AREA_REQUEST,
};

export const areaSuccess = data => ({
  type: AREA_SUCCESS,
  data,
});

export const areaFetch = ({ area }) => async (dispatch) => {
  try {
    const url = 'area';
    dispatch(areaRequest);
    const query = {
      find: {
        code: area,
      },
      select: ['coverage'],
    };
    const data = await fetchEncryptGet(url, query);
    if (!(Array.isArray(data) && data.length > 0)) {
      throw new Error('Error occured at fetching area data');
    }
    dispatch(areaSuccess(data[0].coverage));
  } catch (error) {
    dispatch(areaError(error.message));
  }
};
